export const headers = {
    "Content-Type": "application/json",
    "Authorization": 
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MGM5NjA3ODliNzc4MTAwMjA5YzVhZDAiLCJpYXQiOjE2MjM4MTAxNjh9.bv_8didOSh4ulyq7X2-26eWwS6bjFfRdhTjrVGu9Nsg"
};

export const urlGetUser = "https://coding-challenge-api.aerolab.co/user/me";
export const urlPostCoins = "https://coding-challenge-api.aerolab.co/user/points";
export const urlGetProducts = "https://coding-challenge-api.aerolab.co/products";
export const urlPostRedeem = "https://coding-challenge-api.aerolab.co/redeem";
export const urlGetHistory = "https://coding-challenge-api.aerolab.co/user/history";

export const min = 1000;
export const med = 5000;
export const max = 7500;

export const limit = 16;